import { render, staticRenderFns } from "./LinkedInBlack.vue?vue&type=template&id=3be4e29f&scoped=true&"
import script from "./LinkedInBlack.vue?vue&type=script&lang=js&"
export * from "./LinkedInBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4e29f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be4e29f')) {
      api.createRecord('3be4e29f', component.options)
    } else {
      api.reload('3be4e29f', component.options)
    }
    module.hot.accept("./LinkedInBlack.vue?vue&type=template&id=3be4e29f&scoped=true&", function () {
      api.rerender('3be4e29f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/LinkedInBlack.vue"
export default component.exports